import React from 'react';
import { render } from '@testing-library/react';
import { Card } from './Card';

describe('Card', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Card data-auto-sel="automation-selector">
				<Card.Section key={1}>Top Content</Card.Section>
				<Card.Section key={2}>Middle Content</Card.Section>
				<Card.Section key={3}>Bottom Content</Card.Section>
			</Card>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Card>
				<Card.Section key={1} data-auto-sel="automation-selector">
					Top Content
				</Card.Section>
				<Card.Section key={2}>Middle Content</Card.Section>
				<Card.Section key={3}>Bottom Content</Card.Section>
			</Card>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
